<template>
    <layout>
        <div class="row no-gutters">
            <div class="col-sm-12">
                <table-data
                    :route="url.getList"
                    :settings="table.settings"
                    :columns="table.columns"
                    :inlineFilters="table.filters"
                    :autoUpdateFilter="table.autoUpdateFilter"
                    :addParamsToUrl="table.addParamsToUrl"
                    :loadingMsg="table.loadingMsg"
                    :notFoundMsg="table.notFoundMsg"
                    :orderByTemplate="table.orderByTemplate"
                    tableClass="table-responsive-sm"
                    @error-load="showError"
                >
                    <template v-slot:filters="{ tableFilters, search }">
                        <form autocomplete="false" @submit.prevent="search" @keyup.enter="search">
                            <div class="row header">
                                <div class="col-12">
                                    <header-list
                                        :title="pageTitle"
                                        :placeholderSearch="searchPlaceholder"
                                        v-model="tableFilters.q"
                                        :routeAddName="`${moduleCode}.${pageID}.create`"
                                        :canAdd="canAdd"
                                        :addTitle="addTitle">
                                    </header-list>
                                </div>
                            </div>
                        </form>
                    </template>

                    <template v-slot:body="{row, index, remove}">
                        <td :class="table.columns[0].class">
                            {{row.title}}
                            <span class="ml-1 badge badge-info">{{row.layers_count}}</span>
                        </td>
                        <td :class="table.columns[1].class"><a v-bind:href="row.url" target="_blank">{{row.url}}</a></td>
                        <td :class="table.columns[2].class">{{row.service.description}}</td>
                        <column-actions v-if="checkActions"
                            :routeEdit="`${moduleCode}.${pageID}.show`"
                            @delete="deleteItem"
                            :canDetail="canDetail"
                            :canEdit="canEdit"
                            :canDelete="canDelete"
                            :row="row"
                            :index="index"
                            :callbackDelete="remove" >

                            <li class="list-group-item" v-if="canView">
                                <router-link :to="{ name: `${moduleCode}.${pageID}.view`, params: { id: row.id }  }">
                                    <i class="fas fa-list action view"></i>
                                </router-link>
                            </li>
                            <li class="list-group-item" v-if="canEdit">
                                <a href="#" @click.prevent="confirm(reloadItem, row.id, `Pretende efetuar o reload do serviço <strong>${row.title}</strong> ?`)">
                                    <i class="fas fa-sync-alt action reload"></i>
                                </a>
                            </li>
                        </column-actions>
                    </template>
                </table-data>
            </div>
        </div>
        <modal-confirmation ref="modalConfirmation" title="Remover Serviço" text="Deseja remover o serviço selecionado?"></modal-confirmation>
    </layout>
</template>

<script>
    import GeneralMixin     from './../../mixin';

    export default {
        mixins: [
            GeneralMixin,
        ],
        data() {
            return {
                pageID : 'ogc_remote_services',
                pageTitle : 'List',
                table: {
                    settings: {
                        order_by: 'title',
                    },
                    columns: [
                        {
                            label: 'Title',
                            field: 'title',
                            class: '', //text-truncate
                            sortable: true,
                        },
                        {
                            label: 'URL',
                            field: 'url',
                            class: 'd-none d-sm-table-cell', //text-truncate
                            sortable: false,
                        },
                        {
                            label: 'Type',
                            field: 'ogc_service_id',
                            class: '', //text-truncate
                            sortable: true,
                        },
                        {
                            label: '',
                            field:  null,
                            sortable: false,
                            class: 'actions large',
                        }
                    ],
                },

            }
        },
        methods: {
            confirm(callbac, id, msg) {
                this.$root.$emit('openConfirmation', {
                    id: id,
                    data: {},
                    text: msg,
                    callback: callbac
                });
            },
            reloadItem: function(id) {
                if(this.canEdit) {
                    return this.$http.post(this.formatString(this.url.getReload, { id: id }))
                    .then( res => {
                        this.showMessage(res.data.data);
                        return true;
                    })
                    .catch( error => {
                        this.showHttpError(error);
                        return false;
                    })
                }
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
